import { Button, Stack, Typography, useTheme } from '@mui/material';
import * as Sentry from '@sentry/react';
import { get, map } from 'lodash';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import ImageComponent from 'src/components/common/Image';
import { ICON_NO_MATCH_SEARCH_COMPANY } from 'src/utils/constants/imagesUrl';

export const SectionErrorBoundary = ({
  children,
  contexts,
  sectionName,
  resetKey,
}: {
  children: ReactNode;
  contexts?: Record<string, ExpectedAny>;
  sectionName?: string;
  resetKey?: string;
}) => {
  return (
    <Sentry.ErrorBoundary
      key={resetKey || ''}
      fallback={() => <InlineError />}
      beforeCapture={(scope, event: ExpectedAny) => {
        event.tags = {
          ...event.tags,
          boundary: 'Section Error',
          ...(sectionName && { sectionName }),
        };
        map(Object.keys(contexts || {}), (keyContext) => {
          scope.setContext(keyContext, get(contexts, keyContext, {}));
        });
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

function InlineError() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Stack
      direction="column"
      alignItems="center"
      mt={6}
      spacing={3}
      border={`1px dashed #D6DAFF`}
      borderRadius={`1px dashed ${theme.shape.borderRadius}`}
      padding={theme.spacing(2)}
      bgcolor={theme.palette.background.paper}
    >
      <Stack direction="row" justifyContent="center" spacing={6}>
        <ImageComponent imgSrc={ICON_NO_MATCH_SEARCH_COMPANY} height={150} />
        <Stack direction="column" spacing={1} justifyContent="center">
          <Typography variant="h4">Data is not available at the moment</Typography>
          <Typography variant="body1">Please try again later</Typography>
          <Typography variant="body1">
            This may be due to a temporary connection issue or the data is still being prepared.
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="center" spacing={1.5}>
        <Button onClick={() => navigate('/')} variant="outlined" color="info" size="small">
          Go to Homepage
        </Button>
        <Button onClick={() => window.location.reload()} variant="contained" color="primary" size="small">
          Reload
        </Button>
      </Stack>
    </Stack>
  );
}
